import { Button, ConfigProvider, Layout, Tooltip } from "antd";
import { observer } from "mobx-react";
import styles from "./index.module.scss";
import authStore from "../../stores/authStore";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import AdminClientsView from "./views/Clients/AdminClientsView";
import AdminSettingsView from "./views/Settings/AdminSettingsView";
import AdminPromosView from "./views/Promos/AdminPromosView";
import AdminCouponsView from "./views/Coupons/AdminCouponsView";
import AdminTariffsView from "./views/Tariffs/AdminTariffsView";
import AdminClientView from "./views/Client/AdminClientView";
import AdminPendingPaymentsView from "./views/PendingPayments/AdminPendingPaymentsView";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { CurrencyDollar, FileText, Gear, People, Percent, Star } from "react-bootstrap-icons";

const { Content, Sider, Header } = Layout;

const AdminDashboardView = observer(() => {
  const onLogout = () => {
    authStore.logout();
  };
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBorderRadius: 0,
            colorBgBase: "white",
          },
          Menu: {
            colorBgContainer: "transparent",
            itemSelectedBg: "white",
          },
        },
      }}
    >
      <BrowserRouter>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <Layout>
            <Sider width={60}>
              <div className={styles.logo} />
              <SideMenu />
            </Sider>
            <Layout style={{ backgroundColor: "white" }}>
              <Header className={styles.header}>
                <div className={styles.title}>Панель управления</div>
                <Button onClick={onLogout} type="primary">
                  Выйти
                </Button>
              </Header>
              <Content>
                <Routes>
                  <Route path="clients">
                    <Route index element={<AdminClientsView />} />
                    <Route path=":id" element={<AdminClientView />} />
                  </Route>
                  <Route path="settings" element={<AdminSettingsView />} />
                  <Route path="pendingPayments" element={<AdminPendingPaymentsView />} />
                  <Route path="promos" element={<AdminPromosView />} />
                  <Route path="coupons" element={<AdminCouponsView />} />
                  <Route path="tariffs" element={<AdminTariffsView />} />
                </Routes>
              </Content>
            </Layout>
          </Layout>
        </QueryParamProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
});

export default AdminDashboardView;

function SideMenu() {
  const nav = useNavigate();

  const items = [
    { key: "clients", label: "Клиенты", icon: <People /> },
    { key: "tariffs", label: "Тарифы", icon: <Star /> },
    { key: "pendingPayments", label: "Платежи", icon: <CurrencyDollar /> },
    { key: "promos", label: "Промокоды", icon: <FileText /> },
    { key: "coupons", label: "Купоны", icon: <Percent /> },
    { key: "settings", label: "Настройки", icon: <Gear /> },
  ];

  return (
    <div className={styles.menu}>
      {items.map((e) => (
        <Tooltip title={e.label} key={e.key} placement="left">
          <div className={styles.icon} onClick={() => nav(`/${e.key}`)}>
            {e.icon}
          </div>
        </Tooltip>
      ))}
    </div>
  );
}
